import script from "./VietBaiHangLoat.vue?vue&type=script&setup=true&lang=js"
export * from "./VietBaiHangLoat.vue?vue&type=script&setup=true&lang=js"

import "./VietBaiHangLoat.vue?vue&type=style&index=0&id=0a70a6dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a70a6dd"]])

export default __exports__